var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignLanguage = function SvgSignLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.991 23.133q-3.423-.763-4.401-.994-4.363-.19-4.766-.12l-4.28.737c-.463.08-.91-.195-1.072-.657a1.1 1.1 0 0 1 .058-.862c.135-.267.37-.462.647-.535l3.555-.936-4.389-.102c-.586-.013-1.052-.513-1.057-1.135a1.22 1.22 0 0 1 .332-.851c.214-.226.505-.35.805-.345l4.285.097-4.666-1.104c-.573-.136-.926-.74-.79-1.35.138-.61.56-1.061 1.134-.926l4.823 1.172-3.866-1.826a1.15 1.15 0 0 1-.594-.69c-.1-.307-.076-.647.067-.94.267-.547.878-.799 1.414-.583l6.07 2.447-.616-2.064c-.178-.597.12-1.245.676-1.473a1.06 1.06 0 0 1 1.3.416l2.547 4.45 7.025 1.664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.065 11.702-3.47-2.757a.99.99 0 0 1-.245-1.253 1.1 1.1 0 0 1 .68-.532 1.04 1.04 0 0 1 .838.133L7.99 9.367 5.068 5.966c-.39-.454-.337-1.142.12-1.562a1.2 1.2 0 0 1 .859-.317c.314.012.605.15.805.382l2.855 3.318L7.34 3.505c-.291-.525-.084-1.197.462-1.501s1.17-.285 1.46.241l2.425 4.446-1.285-4.156a1.15 1.15 0 0 1 .104-.913c.16-.281.43-.49.744-.577.588-.164 1.193.132 1.399.684l2.331 6.243 1.11-1.847a1.207 1.207 0 0 1 1.554-.471 1.1 1.1 0 0 1 .58 1.264l-1.562 4.91L20.227 16"
  }))));
};
export default SvgSignLanguage;